
import React, { useEffect, useState } from 'react'
import Header from '../../../../components/header'

import Table from '../../../../components/table'
import { StateSchoolListColumn } from '../../../utility/stateSchoolListColumns'
import Button from '../../../../components/buttonPrimary'
import * as APIs from "../../../../pages/registrationPage/apis";
import * as APIsV2 from '../../../apiCall/api';
import { hideLoader, notifyError, notifySuccess, showLoader } from '../../../../components/loader'
import CustomSelect from '../../../../components/customSelect'
import classes from './styles.module.scss';
import AddNewSchoolByStateModel from './addNewSchoolbyStateModel/AddNewSchoolByStateModel'
import DisableSchool from './disableSchool/DisableSchool'
import UpdateSchoolDetails from './updateSchoolByState';
import Textarea from '../../../../components/textarea'



const SchoolListAddNewSchoolPageContainer = () => {
  // dropdown state 
  const [districtDropDown, setDistrictDropDown] = useState([])
  const [allBlock, setAllBlock] = useState([])
  const [selectedSchool, setSelectedSchool] = useState({});
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [state, setState] = useState({
    district: '',
    block: '',
  })

  const [isEnableModalOpen, setIsEnableModalOpen] = useState(false);
  const handleEditClick = (data) => {
    setSelectedSchool(data);
    setIsUpdateModalOpen(true);
  };



  // for the add new school details
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [allSchool, setAllSchool] = useState([])
  const [isDisableModelOpen, setIsDisableModelOpen] = useState(false);

  // rollback state 
  const [isRollbackModalOpen, setIsRollbackModalOpen] = useState(false);
  const [rollbackComment, setRollbackComment] = useState("");


  // API Handler for Rollback
  const rollbackHandler = async (schoolId) => {
    if (!schoolId) return notifyError("School ID is required");
    if (!rollbackComment.trim()) return notifyError("Please provide a reason for rollback");

    showLoader();
    try {
      // Pass both ID and the comment/reason to your API
      const payload = { comment: rollbackComment };
      const res = await APIsV2.rollbackSchoolApplication(schoolId, payload);

      if (res?.success || res?.status) {
        notifySuccess(res?.data?.message || "Application rolled back successfully");
        setRollbackComment(""); // Reset comment
        setIsRollbackModalOpen(false);
        refreshList();
      } else {
        throw new Error(res?.data?.message || res?.message || "Failed to rollback");
      }
    } catch (error) {
      notifyError(error.message);
    } finally {
      hideLoader();
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      const res = await APIs.getMasterData({
        tablesName: [
          "master_district",
        ],
      });
      if (res.status) {
        setDistrictDropDown(res.data);
      }
    };
    fetchData();
  }, []);
  const refreshList = async () => {
    if (state.district && state.block) {
      onDistrictOrBlock(state.district, state.block);
    }
  };
  // EnableSchool Handler 
  const enableSchoolHandler = async (schoolId) => {
    if (!schoolId) return notifyError("SchoolId is Required");
    showLoader();
    try {
      const res = await APIsV2.enableSchool(schoolId);
      refreshList();
      if (res?.success || res?.data) {
        notifySuccess(res.data.message);
      } else {
        const errorMessage = res?.data.message || res.message || "Failed to Enable School";
        throw new Error(errorMessage);
      }
    } catch (error) {
      notifyError(error.message);
      hideLoader();
    } finally {
      hideLoader();
    }
  }

  const handleDisableSchoolModel = (schoolData) => {
    if (schoolData) {
      setSelectedSchool(schoolData);
      setIsDisableModelOpen(true);
    }

  }

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleAddNewSchool = async (data) => {
    showLoader();
    try {
      const res = await APIsV2.createSchool(data);

      if (res.success || res.status) {
        notifySuccess(res.data.message);
        hideLoader();
        notifySuccess("School created successfully");
        onDistrictOrBlock(state.district, state.block)
        return true;
      } else {
        notifyError(res.message || "Failed to create school");
        hideLoader();
        return false;
      }
    } catch (error) {
      hideLoader();
      const errorMessage = error.response?.data?.message || error.message || "Something went wrong";
      notifyError(errorMessage);
      console.error("API Error:", error);
      return false;
    }
  };

  // disabled school
  const disableSchool = async (schoolId, reason) => {
    if (!schoolId && !reason) {
      return notifyError("Invalid Data field check your schoolId and Reason!");
    }
    showLoader();
    try {
      const payload = {
        reason: reason
      }
      const res = await APIsV2.disableSchool(schoolId, payload);
      if (res.status) {
        refreshList();
      }
      if (!res.success || !res.data) {
        const message = res.data.message || res.message;
        hideLoader();
        throw new Error(message);
      }
    } catch (error) {
      hideLoader();
      notifyError(error.message);
    } finally {
      hideLoader();
    }
  }


  useEffect(() => {

    if (state.district) {
      const getData = async () => {
        let res = await APIs.getCustoDropdown({
          dropdown_code: "block_master",
          districtId: [state.district],
        });
        setAllBlock(res.data);
      };
      getData();
    }
  }, [state.district]);

  const schoolTypeOptions = [
    { label: 'Co-Educational', value: 1 },
    { label: 'Boys School', value: 2 },
    { label: 'Girls School', value: 3 },
  ];

  const mediumOptions = [
    { label: "Hindi", value: 1 },
    { label: "English", value: 2 },
    { label: "Both Hindi and English", value: 3 },
  ];

  // Helper to determine minority status string
  const getMinorityStatus = (d) => {
    const rawMinority = d?.schoolDetails?.minority ?? d?.minority;
    if (rawMinority === null || rawMinority === undefined) return "N/A";
    if (rawMinority == 1) return "Yes";
    if (rawMinority == 0) return "No";
    return rawMinority;
  };

  // Helper to render Status Badge
  const renderStatusBadge = (status) => (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${status === "Active"
      ? "bg-emerald-100 text-emerald-800 border-emerald-200"
      : "bg-slate-100 text-slate-800 border-slate-200"
      }`}>
      <span className={`w-1.5 h-1.5 mr-1.5 rounded-full ${status === "Active" ? "bg-emerald-500" : "bg-slate-500"}`}></span>
      {status || "N/A"}
    </span>
  );

  // Helper to render Action Buttons
  const renderActionButtons = (d) => (
    <div className="flex items-center flex-col gap-3">
      <button
        className="px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-md transition-colors"
        onClick={() => handleEditClick(d)}
      >
        Update
      </button>

      {(!d?.isRollback && d?.schoolDetails !== null) && (
        <button
          className="px-3 py-1.5 text-xs font-medium text-amber-700 bg-amber-50 hover:bg-amber-100 border border-amber-200 rounded-md transition-colors"
          onClick={() => {
            setSelectedSchool(d);
            setIsRollbackModalOpen(true);
          }}
        >
          Rollback
        </button>
      )}

      {d?.status === "Active" ? (
        <button
          className="px-3 py-1.5 text-xs font-medium text-rose-700 bg-rose-50 hover:bg-rose-100 border border-rose-200 rounded-md transition-colors"
          onClick={() => handleDisableSchoolModel(d)}
        >
          Disable
        </button>
      ) : (
        <button
          className="px-3 py-1.5 text-xs font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded-md transition-colors"
          onClick={() => {
            setSelectedSchool(d);
            setIsEnableModalOpen(true);
          }}
        >
          Enable
        </button>
      )}
    </div>
  );

  const onDistrictOrBlock = async (districtId, blockId) => {
    if (!districtId || !blockId) {
      notifyError(!districtId ? "Please select District" : "Please select Block");
      return;
    }

    showLoader();
    let res = await APIsV2.getSchoolList({
      districtId: districtId,
      blockId: blockId,
      limit: 10000,
    });

    if (res.status) {
      const mappedData = res.data.data.map((d, index) => {
        // 1. Fallback Logic for School Type
        const typeObj = schoolTypeOptions.find(opt => opt.value === d?.schoolTypeId);
        const displaySchoolType = d?.schoolDetails?.schoolType || (typeObj ? typeObj.label : "N/A");

        // 2. Fallback Logic for Medium
        const mediumObj = mediumOptions.find(opt => Number(opt.value) === Number(d?.schoolMedium));
        const displayMedium = d?.schoolDetails?.mediumOfInstruction || (mediumObj ? mediumObj.label : "N/A");

        const displayIsClosed = (d?.schoolDetails?.isSchoolClosed == 1) ? "Yes" : "No";

        return {
          s_n: index + 1,
          schoolName: d?.schoolName,
          schoolAddress1: d?.schoolAddress1,
          schoolType: displaySchoolType,
          schoolMedium: displayMedium,
          pinCode: d?.pinCode,
          schoolId: d?.schoolId,
          loginCode: d?.loginCode ? d?.loginCode : "N/A",
          minority: getMinorityStatus(d),
          UDISE_Code: d?.schoolCode ? d?.schoolCode : "N/A",
          isSchoolClosed: displayIsClosed,
          levelOfEducation: d?.schoolDetails ? d?.schoolDetails?.levelOfEducation : "N/A",
          highestClass: d?.schoolDetails ? d?.schoolDetails?.highestClass : "N/A",
          boardOfEducation: d?.schoolDetails ? d?.schoolDetails?.boardOfEducation : "N/A",
          Status: renderStatusBadge(d?.status),
          Actions: renderActionButtons(d)
        };
      });
      setAllSchool(mappedData);
      hideLoader();
    } else {
      hideLoader();
      notifyError("Failed to fetch school data");
    }
  };




  return (
    <div >
      <Header header_text="Search School Details" />


      <div className='flex justify-end'>


        <div className='w-[65%] flex gap-4 py-6   '>

          <CustomSelect
            options={districtDropDown?.masterDistrict}
            placeholder="Select District"
            onChange={(e) => handleChange(e)}
            name="district"
            optionLabel="name"
            optionValue={"id"}
            label={"District"}
          />
          <CustomSelect
            options={allBlock}
            placeholder="Select Block"
            // second_class={classes.medium}
            onChange={(e) => handleChange(e)}
            // value={state.gender}
            name="block"
            optionLabel="blockName"
            label={"Block"}
            optionValue={"blockId"}
          />

          <div className='flex gap-4  ' style={{ alignItems: "end", }}>
            <Button button_text="Search"
              variant="button_blue"
              second_className={classes.btn_style}
              onClick={() => onDistrictOrBlock(state.district, state.block)}
            />
            <Button button_text="Add New"
              variant="button_blue"
              onClick={() => setIsModalOpen(true)}
              second_className={classes.btn_style}
            >
            </Button>
          </div>

        </div>
      </div>


      <div className=' pb-6'>
        <Table columns={StateSchoolListColumn} rows={allSchool} />
      </div>

      {
        isModalOpen && (
          <AddNewSchoolByStateModel
            onClose={() => setIsModalOpen(false)}
            onSubmit={handleAddNewSchool}
          />
        )
      }

      {/* rollback model  */}
      {isRollbackModalOpen && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-[800px] flex flex-col transform transition-all animate-in fade-in zoom-in duration-200">

            {/* Header */}
            <div className="px-8 py-4 border-b flex justify-between items-center bg-slate-50 rounded-t-2xl">
              <div>
                <h2 className="text-xl font-bold text-slate-800-800">Confirm Application Rollback</h2>
                <p className='text-slate-800 mt-1 font-medium'>{selectedSchool?.schoolName}</p>
              </div>

              <button
                onClick={() => {
                  setIsRollbackModalOpen(false);
                  setRollbackComment("");
                }}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white  text-red-500 transition-all"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className='p-4'>

              <div className="p-4 rounded-xl border border-slate-100">
                <Textarea
                  label="Rollback Reason"
                  star="*"
                  placeholder="Please explain why this application is being rolled back..."
                  value={rollbackComment}
                  onChange={(e) => setRollbackComment(e.target.value)}
                  required={true}

                />
              </div>

              {/* Actions */}
              <div className="flex justify-end gap-3  pt-6 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setIsRollbackModalOpen(false);
                    setRollbackComment("");
                  }}
                  className="px-8 py-2.5 rounded-lg font-bold bg-slate-200 text-slate-700 hover:bg-slate-300 transition-all"
                >
                  Cancel
                </button>
                <button
                  onClick={() => rollbackHandler(selectedSchool.schoolId)}
                  className="px-10 py-2.5 rounded-lg font-bold bg-blue-600 text-white hover:bg-blue-700 shadow-md hover:shadow-amber-200 transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={!rollbackComment.trim()}
                >
                  Confirm Rollback
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {isEnableModalOpen && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-[600px] flex flex-col transform transition-all animate-in fade-in zoom-in duration-200">

            {/* Header - Matching DisableSchool Style */}
            <div className="px-8 py-4 border-b flex justify-between items-center bg-slate-50 rounded-t-2xl">
              <div>
                <h2 className="text-xl font-bold text-slate-800">Enable School</h2>
                <p className='text-slate-800'>{selectedSchool?.schoolName}</p>
              </div>
              <button
                onClick={() => setIsEnableModalOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-500 transition-all"
              >
                ✕
              </button>
            </div>

            {/* Body Content */}
            <div className="p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center shrink-0">
                  <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <p className="text-lg text-slate-700">
                    Are you sure you want to enable
                  </p>
                  <p className="text-sm text-slate-500 mt-2 leading-relaxed">
                    Enabling this school will restore its "Active" status, making it visible for registrations and administrative tasks again.
                  </p>
                </div>
              </div>

              {/* Actions - Matching DisableSchool Button Style */}
              <div className="flex justify-end gap-3 mt-10 pt-6 border-t">
                <button
                  type="button"
                  onClick={() => setIsEnableModalOpen(false)}
                  className="px-8 py-2.5 rounded-lg font-bold bg-slate-200 text-slate-700 hover:bg-slate-300 transition-all"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    enableSchoolHandler(selectedSchool.schoolId);
                    setIsEnableModalOpen(false);
                  }}
                  className="px-10 py-2.5 rounded-lg font-bold bg-emerald-600 text-white hover:bg-emerald-700 shadow-md hover:shadow-emerald-200 transition-all active:scale-95"
                >
                  Confirm Enable
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {
        isDisableModelOpen && (
          <DisableSchool
            onClose={() => setIsDisableModelOpen(false)}
            schoolData={selectedSchool}
            DisableSchool={(schoolId, reason) => disableSchool(schoolId, reason)}
          />
        )
      }
      {isUpdateModalOpen && (
        <UpdateSchoolDetails
          schoolData={selectedSchool}
          onClose={() => setIsUpdateModalOpen(false)}
          onUpdateSuccess={refreshList}
        />
      )}
    </div>
  )
}

export default SchoolListAddNewSchoolPageContainer